export enum LangTypeEnum {
  RU = 'ru',
  // EN = 'en',
}

export interface ILang {
  title: string;
  lang: LangTypeEnum;
}
